<anfrage-live-sharing></anfrage-live-sharing>
<div class="h-100 d-flex overflow-y-auto overflow-x-hidden">
    <prozess-navigation class="navigation" [ngClass]="{ 'collapsed': !showProzessNavigation, 'collapsed-mobile': showProzessNavigation }">
        <div>
            <app-navigation-item
                *ngFor="let navItem of navItemList"
                [name]="navItem.name"
                [href]="getLink(navItem)"
                [isValid]="getStatusFor(navItem.id) == 1"
                [isActive]="isCurrentRoute(navItem.abschnitt)"
                [showValidationStatus]="false"
                >
                <i icon [ngClass]="[navItem.icon]" class="p-1"></i>
                <kendo-icon iconStatus [name]="iconReportStatus(navItem.id)" title="{{iconReportStatusTitle(navItem.id) | translate}}"></kendo-icon>
    
                <div group *ngIf="navItem.childAbschnitte && navItem.childAbschnitte.length > 0 && isParentOpen(navItem.abschnitt)">
                    <app-navigation-item
                        *ngFor="let navItemChild of navItem.children"
                        [name]="navItemChild.name"
                        [href]="navItemChild.link"
                        [isValid]="getStatusFor(navItemChild.id) == 1"
                        [showValidationStatus]="showValidationStatus(navItem.id)"
                        [isSubItem]="true"
                        [isActive]="isCurrentRoute(navItem.abschnitt, navItemChild.abschnitt)"
                        >
                    </app-navigation-item>
                    <app-navigation-item
                    *ngIf="showAbsenden"
                    [name]="GetAbsendenText"
                    href="./dataprotection"
                    [isValid]="getStatusFor('dataprotection') == 1"
                    [showValidationStatus]="showValidationStatus(navItem.id)"
                    [isSubItem]="true"
                    [isActive]="isDataprotectionRoute()"
                    >
                    <i icon class="dataprotection-icon p-1"></i>
                    </app-navigation-item>
                </div>
            </app-navigation-item>
        </div>
    </prozess-navigation>

    <main class="content" [ngClass]="{ 'hidden': !showProzessNavigation }">
        <div id="topPosition"></div>
        <router-outlet></router-outlet>
    </main>
    
    <anfrage-infoarea class="info" [ngClass]="{ 'hidden': ! showAnfrageInfo }"></anfrage-infoarea>
</div>